import { Button } from '@repo/studio-design-system-ui-button'
import { useTrialCta } from '@repo/studio-hooks-payments/use-trial-cta'
import 'payments/payments-dialog/styles.css'
import { tw } from 'utils/classnames'
import { m } from 'framer-motion'

export const GLOW_STYLE = {
  boxShadow: '0 0 0 8px rgba(14, 173, 91, 0.16)',
}

export function TryForFreeButton({
  className,
  style,
  size = 'small',
}: {
  className?: string
  style?: React.CSSProperties
  size?: 'small' | 'medium'
}) {
  const { label, onClick } = useTrialCta()

  return (
    <Button
      size={size === 'medium' ? 'md' : 'sm'}
      variant="promotional"
      className={className}
      style={style}
      onClick={onClick}
    >
      {label}
    </Button>
  )
}

export function TryForFreeStickyButton({ className }: { className?: string }) {
  return (
    <m.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.3, ease: 'easeInOut' }}
      className={tw('sticky inset-0 flex justify-center items-end pointer-events-none', className)}
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div
        className="absolute w-full bottom-0 h-32 bg-gray-1000"
        style={{
          backdropFilter: 'blur(8px)',
          maskImage: 'linear-gradient(to bottom, transparent 0%, black 100%)',
        }}
      />
      <TryForFreeButton className="pointer-events-auto mb-8" size="medium" style={GLOW_STYLE} />
    </m.div>
  )
}
